import React, { useState } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import { LinkExternal } from '../LinkExternal'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import { ButtonAddWithLabel } from 'Components/Buttons/ButtonAddWithLabel'

import styles from './styles.js'

import { USER_DOCUMENT_HEADERS } from './options'
import ActionsBlock from './ActionsBlock'

import { showReduxModal } from '../../Reducers/UI/actions'
import { useDispatch } from 'react-redux'

import classNames from 'classnames'
import { deleteUserDocument } from '../../Containers/City/Page/Ambasador/gql'
import UploadDocModalBody from './ActionModals/UploadDocModalBody'
import DeleteDocModalBody from './ActionModals/DeleteDocModalBody'

const DocumentHistoryTable = ({
  documentsData: docsFromProps,
  otherDocumentType,
  updateUserDocument,
  documentType,
  ambassador,
  nmbrsDocument,
  handleUploadDocument,
  setNmbrsDocument,
  classes,
}) => {
  const [documents, setDocuments] = useState(docsFromProps)
  const dispatch = useDispatch()

  const handleCellChange = (value, row, key) => {
    const newDocuments = documents.map(document => {
      return document.id === row.id
        ? {
            ...document,
            [key]: value,
          }
        : document
    })

    setDocuments(newDocuments)
  }

  const onEdit = async row => {
    const newDocuments = documents.map(document => {
      return document.id === row.id
        ? {
            ...document,
            isEdit: true,
          }
        : { ...document, isEdit: document.isEdit }
    })

    setDocuments(newDocuments)
  }

  const onSave = async document => {
    try {
      const actualDocumentData = documents.find(doc => doc.id == document.id)

      await updateUserDocument({
        input: {
          id: document.id,
          comment: actualDocumentData.comment,
          rejectReason: actualDocumentData.rejectReason,
        },
      })
      const newDocuments = documents.map(doc => {
        return doc.id === document.id
          ? {
              ...document,
              isEdit: false,
            }
          : doc
      })

      setDocuments(newDocuments)
    } catch (error) {}
  }

  const onMakePrimary = async document => {
    try {
      await updateUserDocument({
        input: {
          id: document.id,
          isPrimary: true,
        },
      })
      const newDocuments = documents.map(doc => {
        return doc.id === document.id
          ? {
              ...doc,
              isEdit: false,
              isPrimary: true,
            }
          : { ...doc, isPrimary: false }
      })

      setDocuments(newDocuments)
    } catch (error) {}
  }

  const renderTableCell = (row, key, type) => {
    switch (type) {
      case 'string':
        return row && row[key] ? (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {row[key] || '-'}
          </Typography>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {'-'}
          </Typography>
        )
      case 'url':
        return row && row[key] ? (
          <LinkExternal href={row[key]} target="_blank">
            View
          </LinkExternal>
        ) : (
          '-'
        )
      case 'date':
        return (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {row && row[key]
              ? moment(Number(row[key])).format('YYYY/MM/DD HH:mm')
              : '-'}
          </Typography>
        )

      case 'input':
        return (row && row[key]) || (row && row.isEdit) ? (
          <OutlinedInput
            id={`${row.name}-${key}`}
            value={row[key]}
            disabled={!row.isEdit}
            sx={{
              '& .notchedOutline': {
                border: 'none',
              },
            }}
            multiline={true}
            onChange={event => {
              const { value } = event.target
              if (row.isCustomData) {
                return setNmbrsDocument({ ...nmbrsDocument, comment: value })
              }
              return handleCellChange(value, row, key)
            }}
            classes={{
              input: row.isEdit ? classes.editInput : classes.outlinedInput,
              root: classes.outlinedInputRoot,
            }}
          />
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {'-'}
          </Typography>
        )
      case 'actions':
        return row && row[key] !== null && row[key] !== undefined ? (
          <ActionsBlock
            document={row}
            setDocuments={setDocuments}
            onEdit={onEdit}
            onSave={onSave}
            onMakePrimary={onMakePrimary}
            onDelete={openDeleteModal}
          />
        ) : (
          <Typography className={classes.text}>{'-'}</Typography>
        )

      default:
        return <Typography>{row[key]}</Typography>
    }
  }

  const onDeleteConfirm = async document => {
    try {
      const input = { id: document.id }
      await deleteUserDocument({
        input,
      })
      const newDocuments = documents.filter(doc => doc.id !== document.id)

      setDocuments(newDocuments)
    } catch (error) {
      /* eslint-disable */
      console.log(`DELETE_DOC_ERROR:${error}`)
    }
  }

  const openDeleteModal = ({ document }) => {
    return dispatch(
      showReduxModal({
        children: (
          <DeleteDocModalBody
            onConfirm={async () => await onDeleteConfirm(document)}
          />
        ),
        hideButtons: true,
      }),
    )
  }

  const showAddDocModal = () => {
    return dispatch(
      showReduxModal({
        children: (
          <UploadDocModalBody
            handleUploadDocument={handleUploadDocument}
            ambassador={ambassador}
            typeId={documentType ? documentType.id : otherDocumentType.id}
          />
        ),
        hideButtons: true,
      }),
    )
  }
  return (
    <Box className={classes.wrapper}>
      <Box className={classes.table}>
        <TableContainer className={classes.tableContainer}>
          <div className={classes.header}>
            <div className={classes.headerTitle}>
              {documentType ? documentType.name : 'Other'}
            </div>
            {otherDocumentType ? (
              <ButtonAddWithLabel
                size={'small'}
                onClickHandler={showAddDocModal}
                label={'Add file'}
                icon={'upload'}
              />
            ) : null}
          </div>
          <Table stickyHeader size="medium">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                {USER_DOCUMENT_HEADERS.map((headCell, index) => (
                  <TableCell
                    key={headCell.key}
                    align={
                      index === USER_DOCUMENT_HEADERS.length - 1
                        ? 'center'
                        : 'left'
                    }
                    className={
                      index !== 0
                        ? classes.tableHeaderCell
                        : classes.firstTableHeaderCell
                    }
                  >
                    <Typography className={classes.tableHeadersLabel}>
                      {headCell.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {documents &&
                documents
                  .sort((doc1, doc2) => doc2.id - doc1.id)
                  .map(row => {
                    return (
                      <TableRow
                        hover={false}
                        tabIndex={-1}
                        key={row.id}
                        className={classNames({
                          [classes.tableRow]: true,
                          [classes.activeDoc]: row.isPrimary && documentType,
                        })}
                      >
                        {USER_DOCUMENT_HEADERS.map(({ key, type }, index) => {
                          return index === USER_DOCUMENT_HEADERS.length - 1 ? (
                            <TableCell align={'center'}>
                              {renderTableCell(row, key, type)}
                            </TableCell>
                          ) : (
                            <TableCell align={'left'}>
                              {renderTableCell(row, key, type)}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    )
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export default injectStyles(styles)(DocumentHistoryTable)
